import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch
} from 'react-router-dom'
import { MSPClasses } from '@cms-max/medicare-api-sdk'
import { fetchMspSummaries, Status } from 'redux/helpers/claimCase'
import { cookieInterfaces } from 'utils/cookies'
import { MsaDisclaimerPage } from './MsaDisclaimerPage'
import { MsaMainPage } from './MsaMainPage'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { getStatus } from 'redux/reducers/msa'

type DisclaimerCheckProps = {
  acceptedDisclaimer: boolean
  children: React.ReactNode
}
const DisclaimerCheck = ({
  acceptedDisclaimer,
  children
}: DisclaimerCheckProps) => {
  const { path } = useRouteMatch()

  if (!acceptedDisclaimer) {
    return <Redirect to={`${path}/disclaimer`} />
  }
  return <>{children}</>
}

export const MSA: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const flags = useFlags()
  useEffect(() => {
    dispatch(fetchMspSummaries({
      classType: MSPClasses.MsaSummary,
      useOnlySlsJwtForAuthByDefault: flags?.useOnlySlsJwtForAuthByDefault
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps --- we don't need flags here because they shouldn't change, and LD should be loaded before this component renders since it's behind LaunchDarklyDependentContent
  }, [dispatch])

  const [acceptedDisclaimer, setAcceptedDisclaimer] = useState(
    Boolean(cookieInterfaces.acceptedMsaDisclaimer.get())
  )
  useEffect(() => {
    if (acceptedDisclaimer) {
      cookieInterfaces.acceptedMsaDisclaimer.set('true')
    }
  }, [acceptedDisclaimer])
  const handleAcceptDisclaimer = () => {
    setAcceptedDisclaimer(true)
    history.push('/claims/msa')
  }

  const status = useSelector(getStatus)

  return (
    <Switch>
      <Route path={`/claims/msa/disclaimer`}>
        {status !== Status.LOADING && (
          <MsaDisclaimerPage onAccept={handleAcceptDisclaimer} />
        )}
      </Route>
      <Route path={`/claims/msa`}>
        <DisclaimerCheck acceptedDisclaimer={acceptedDisclaimer}>
          <MsaMainPage />
        </DisclaimerCheck>
      </Route>
    </Switch>
  )
}

export default MSA
